import { MusicNotes, Brain, ChartBar, type Icon } from '@phosphor-icons/react';

interface BottomNavProps {
  view: string;
  onChange: (view: string) => void;
}

const ITEMS: Array<[string, string, Icon]> = [
  ['library', 'Drum', MusicNotes],
  ['cognitive', 'Mind', Brain],
  ['records', 'Records', ChartBar],
];

function BottomNav({ view, onChange }: BottomNavProps) {
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      {ITEMS.map(([id, label, IconComponent]) => (
        <button key={id} className={view === id ? 'active' : ''} onClick={() => onChange(id)}>
          <IconComponent weight={view === id ? 'fill' : 'regular'} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
